
















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { IssueResponse } from '@/api/types';
import { ClientComments, ClientReactions } from '@/api';

import GtAvatar from './GtAvatar.vue';
import GtSvg from './svg/GtSvg.vue';

@Component<GtComment>({
  components: {
    GtAvatar,
    GtSvg,
  },
})
export default class GtComment extends Vue {
  @Prop({ type: Array, default: () => [] }) readonly admin!: string[]
  @Prop({ type: Object, required: true }) readonly comment!: ClientComments
  @Prop({ type: Object, default: () => null }) readonly user!: IssueResponse['user']

  get isAdmin() {
    return [...this.admin]
      .map((item) => item.toLowerCase())
      .indexOf(this.comment.user.login.toLowerCase()) !== -1;
  }

  /**
   * 可否編輯，
   * 登入使用者與該篇回應作者相同才可以修改
   */
  get enableEdit() {
    const { user, comment } = this;
    return user && comment.user.login === user.login;
  }

  get reactions() {
    return this.comment.reactions;
  }

  emitCommentReply() {
    this.$emit('reply', this.comment);
  }

  emitReactions(content: keyof ClientReactions) {
    // 如果沒登入就停止動作
    if (!this.user) { return; }
    this.$emit('reaction', {
      comment: this.comment,
      content,
    });
  }
}
